<div class="row page-header">
    <div class="col-12">
        <h1>Safety <small>View employee incidents and loss claims over time</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Safety Analytics</a>
            <ng-template ngbNavContent>
                <div class="row action-toolbar">
                    <div class="col-12">
                        <form class="form-inline">
                            <wj-combo-box
                                name="selectedTimeunit"
                                [itemsSource]="timeunits"
                                (selectedIndexChanged)="refresh()"
                                [displayMemberPath]="'display'"
                                [selectedValuePath]="'value'"
                                [(ngModel)]="selectedTimeunit"
                            >
                            </wj-combo-box>
                        </form>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <wj-flex-chart
                            [itemsSource]="timeSeries"
                            [bindingX]="'date'"
                            [chartType]="'Line'"
                            style="height: 300px"
                            [header]="'Total Incidents'"
                        >
                            <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                            <wj-flex-chart-axis
                                [wjProperty]="'axisY'"
                                [title]="'Incident Count'"
                                [format]="'N2'"
                                [min]="0"
                                [max]="maxIncidentRange"
                            ></wj-flex-chart-axis>
                            <wj-flex-chart-series [binding]="'incidentCount'" [name]="'Incidents'"></wj-flex-chart-series>
                            <!--<wj-flex-chart-data-label content="{value}" position="Top"></wj-flex-chart-data-label>-->
                            <wj-flex-chart-annotation-layer control="al">
                                @for (annotation of mitigationGrid.items; track annotation) {
                                    <wj-flex-chart-annotation-text
                                        [attachment]="'DataIndex'"
                                        [text]="annotation.chartLabel"
                                        position="Center"
                                        [pointIndex]="annotation.pointIndex"
                                        [point]="{ x: 20, y: 20 }"
                                        tooltip="{{ annotation.description }}"
                                        [style]="{ fill: '#bbbbbb', 'font-size': '18px' }"
                                    ></wj-flex-chart-annotation-text>
                                }
                            </wj-flex-chart-annotation-layer>
                        </wj-flex-chart>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <wj-flex-chart
                            [itemsSource]="timeSeries"
                            [bindingX]="'date'"
                            [chartType]="'Line'"
                            appAutoSize
                            [header]="'Total Incurred Amount'"
                        >
                            <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                            <wj-flex-chart-axis
                                [wjProperty]="'axisY'"
                                [title]="'Incurred Amount'"
                                [min]="0"
                                [max]="maxIncurredRange"
                                [format]="'C0'"
                            ></wj-flex-chart-axis>
                            <wj-flex-chart-series [binding]="'incurrendAmount'" [name]="'Incurred'"></wj-flex-chart-series>
                            <!--<wj-flex-chart-data-label content="{value}" position="Top"></wj-flex-chart-data-label>-->
                            <wj-flex-chart-annotation-layer control="al">
                                @for (annotation of mitigationGrid.items; track annotation) {
                                    <wj-flex-chart-annotation-text
                                        [attachment]="'DataIndex'"
                                        [text]="annotation.chartLabel"
                                        position="Center"
                                        [pointIndex]="annotation.pointIndex"
                                        [point]="{ x: 20, y: 20 }"
                                        tooltip="{{ annotation.description }}"
                                        [style]="{ fill: '#bbbbbb', 'font-size': '18px' }"
                                    ></wj-flex-chart-annotation-text>
                                }
                            </wj-flex-chart-annotation-layer>
                        </wj-flex-chart>
                    </div>
                    <div class="col-6">
                        <wj-flex-chart
                            [itemsSource]="incidentMonthChartData"
                            [bindingX]="'month'"
                            [chartType]="'Column'"
                            appAutoSize
                            [header]="'Incidents By Month'"
                        >
                            <wj-flex-chart-legend [position]="'Bottom'"></wj-flex-chart-legend>
                            <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'Count'"></wj-flex-chart-axis>
                            <wj-flex-chart-series [binding]="'affinity'" [name]="'Affinity'"></wj-flex-chart-series>
                            <wj-flex-chart-series [binding]="'viewpoint'" [name]="'Viewpoint'"></wj-flex-chart-series>
                        </wj-flex-chart>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Mitigation Events</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="mitigationGrid"></action-toolbar-count>
                                    <action-toolbar-buttons
                                        [grid]="mitigationGrid"
                                        [canEdit]="canEdit"
                                        [showAdd]="true"
                                        [showEdit]="true"
                                        [showDelete]="true"
                                    ></action-toolbar-buttons>
                                    <action-toolbar-search name="search" [(ngModel)]="mitigationGrid.filter"></action-toolbar-search>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridMitigation"
                                    #gridMitigation
                                    appAutoSize
                                    (initialized)="mitigationGrid.initialize(gridMitigation)"
                                    (destroy)="mitigationGrid.destroy()"
                                    [itemsSource]="mitigationGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Chart Label'"
                                        [binding]="'chartLabel'"
                                        [width]="'*'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Description'"
                                        [binding]="'description'"
                                        [width]="'3*'"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="false">
            <a ngbNavLink>Affinity Safety Demographics</a>
            <ng-template ngbNavContent>
                <div class="row action-toolbar" style="margin-top: 20px">
                    <div class="col-12">
                        <form class="form-inline">
                            <div class="input-header-group">
                                <span class="input-header">Start Date</span>
                                <wj-input-date
                                    [(ngModel)]="demographicStartDate"
                                    (ngModelChange)="refresh()"
                                    name="demographicStartDate"
                                    style="width: 125px; height: 32px; margin-top: 4px"
                                ></wj-input-date>
                            </div>
                            <div class="input-header-group">
                                <span class="input-header">End Date</span>
                                <wj-input-date
                                    [(ngModel)]="demographicEndDate"
                                    (ngModelChange)="refresh()"
                                    name="demographicEndDate"
                                    style="width: 125px; height: 32px; margin-top: 4px"
                                ></wj-input-date>
                            </div>
                            <span style="font-size: 16px; line-height: 32px">Incidents with no HrRef: {{ noHrrefCount }}</span>
                        </form>
                    </div>
                </div>
                <div class="row">
                    @for (entry of demographicsByType | keyvalue; track entry.key) {
                        <div class="col">
                            <h5>{{ entry.key }}</h5>
                            @for (item of $any(entry).value; track item) {
                                <div style="margin-bottom: 20px">
                                    <h6 style="margin-bottom: 0">{{ item.subDemo }}</h6>
                                    <table>
                                        <tr>
                                            <td>Incidents:</td>
                                            <td>
                                                <b>{{ item.incidentCount }}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Incurred:</td>
                                            <td>
                                                <b>{{ item.totalIncurred | currency: 'USD' : 'symbol-narrow' : '1.0-0' }}</b>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            }
                        </div>
                    }
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="4" [destroyOnHide]="false">
            <a ngbNavLink>Affinity Incident Data</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="incidentGrid"></action-toolbar-count>
                                    <button type="button" class="btn btn-sm btn-secondary" (click)="fileInput.click()">Upload Excel</button>
                                    <input style="display: none" type="file" single (change)="onFileChanged($event)" #fileInput />
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridIncident"
                                    #gridIncident
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="incidentGrid.initialize(gridIncident)"
                                    (destroy)="incidentGrid.destroy()"
                                    [itemsSource]="incidentGrid.view"
                                    [itemFormatter]="incidentGridItemFormatter"
                                    (cellEditEnding)="cellEditEnding(gridIncident, $event)"
                                    (cellEditEnded)="cellEditEnded(gridIncident, $event)"
                                    (pasting)="pasting(gridIncident, $event)"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <!--<wj-flex-grid-column [header]="'Claim Number'" [binding]="'claimNumber'" [width]="180" [isReadOnly]="true"></wj-flex-grid-column>-->
                                    <wj-flex-grid-column
                                        [header]="'Accident Date'"
                                        [binding]="'accidentDate'"
                                        [width]="105"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Claimant Name'"
                                        [binding]="'claimantName'"
                                        [width]="220"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Hr Ref'"
                                        [binding]="'hrRef'"
                                        [format]="'d'"
                                        [width]="75"
                                        [isReadOnly]="false"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Employee Name'"
                                        [binding]="'employeeName'"
                                        [width]="220"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Tenure (Days)'"
                                        [binding]="'tenureDays'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Coverage Group'"
                                        [binding]="'coverageGroup'"
                                        [width]="200"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'WC Claim Type'"
                                        [binding]="'wcClaimType'"
                                        [width]="110"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Status'"
                                        [binding]="'status'"
                                        [width]="80"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Incurred'"
                                        [binding]="'totalIncurred'"
                                        [width]="95"
                                        [format]="'C0'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Days Open'"
                                        [binding]="'totalDaysOpen'"
                                        [width]="80"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Loss Description'"
                                        [binding]="'lossDescription'"
                                        [minWidth]="250"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridIncident"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="5" [destroyOnHide]="false">
            <a ngbNavLink>Viewpoint Safety Demographics</a>
            <ng-template ngbNavContent>
                <div class="row action-toolbar" style="margin-top: 20px">
                    <div class="col-12">
                        <form class="form-inline">
                            <div class="input-header-group">
                                <span class="input-header">Start Date</span>
                                <wj-input-date
                                    [(ngModel)]="demographicStartDate"
                                    (ngModelChange)="refresh()"
                                    name="demographicStartDate"
                                    style="width: 125px; height: 32px; margin-top: 4px"
                                ></wj-input-date>
                            </div>
                            <div class="input-header-group">
                                <span class="input-header">End Date</span>
                                <wj-input-date
                                    [(ngModel)]="demographicEndDate"
                                    (ngModelChange)="refresh()"
                                    name="demographicEndDate"
                                    style="width: 125px; height: 32px; margin-top: 4px"
                                ></wj-input-date>
                            </div>
                            <span style="font-size: 16px; line-height: 32px">Incidents with no HrRef: {{ vpNoHrrefCount }}</span>
                        </form>
                    </div>
                </div>
                <div class="row">
                    @for (entry of vpDemographicsByType | keyvalue; track entry.key) {
                        <div class="col">
                            <h5>{{ entry.key }}</h5>
                            @for (item of $any(entry).value; track item) {
                                <div style="margin-bottom: 20px">
                                    <h6 style="margin-bottom: 0">{{ item.subDemo }}</h6>
                                    <table>
                                        <tr>
                                            <td>Incidents:</td>
                                            <td>
                                                <b>{{ item.incidentCount }}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Incurred:</td>
                                            <td>
                                                <b>{{ item.totalIncurred | currency: 'USD' : 'symbol-narrow' : '1.0-0' }}</b>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            }
                        </div>
                    }
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="6" [destroyOnHide]="false">
            <a ngbNavLink>Viewpoint Incident Data</a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="vpIncidentGrid"></action-toolbar-count>
                                    <button type="button" class="btn btn-sm btn-secondary" (click)="fileInput.click()">Upload Excel</button>
                                    <input style="display: none" type="file" single (change)="onFileChanged($event)" #fileInput />
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="gridVpIncident"
                                    #gridVpIncident
                                    appAutoSize
                                    [padding]="73"
                                    (initialized)="vpIncidentGrid.initialize(gridVpIncident)"
                                    (destroy)="vpIncidentGrid.destroy()"
                                    [itemsSource]="vpIncidentGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <!--<wj-flex-grid-column [header]="'Claim Number'" [binding]="'claimNumber'" [width]="180" [isReadOnly]="true"></wj-flex-grid-column>-->
                                    <wj-flex-grid-column
                                        [header]="'Accident Date'"
                                        [binding]="'accidentDate'"
                                        [width]="105"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Claim Number'"
                                        [binding]="'claimNumber'"
                                        [width]="220"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Hr Ref'"
                                        [binding]="'hrRef'"
                                        [format]="'d'"
                                        [width]="75"
                                        [isReadOnly]="false"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Employee Name'"
                                        [binding]="'employeeName'"
                                        [width]="220"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Tenure (Days)'"
                                        [binding]="'tenureDays'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Coverage Group'"
                                        [binding]="'coverageGroup'"
                                        [width]="200"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'WC Claim Type'"
                                        [binding]="'wcClaimType'"
                                        [width]="110"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Status'"
                                        [binding]="'status'"
                                        [width]="80"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Incurred'"
                                        [binding]="'totalIncurred'"
                                        [width]="95"
                                        [format]="'C0'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Days Open'"
                                        [binding]="'totalDaysOpen'"
                                        [width]="80"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Loss Description'"
                                        [binding]="'lossDescription'"
                                        [minWidth]="250"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                                <grid-selection-calculation [grid]="gridVpIncident"></grid-selection-calculation>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
